<template>
  <div class="ml_page">
    <div class="img_box">
      <img src="../../assets/18.png" alt="" />
    </div>
    <div class="img_box">
      <img src="../../assets/19.png" alt="" />
      <a :href="'tel:'+tel" class="btn1"></a>
    </div>
    <div class="img_box">
      <img src="../../assets/20.png" alt="" />
    </div>
    <div class="img_box">
      <img src="../../assets/21.png" alt="" />
       <a :href="'tel:'+tel" class="btn2"></a>
    </div>
    <div class="img_box">
      <img src="../../assets/22.png" alt="" />
    </div>
    <div class="img_box">
      <img src="../../assets/23.png" alt="" />
    </div>
    <div class="img_box">
      <img src="../../assets/24.png" alt="" />
      <a :href="'tel:'+tel" class="btn3"></a>
    </div>
    <div class="img_box">
      <img src="../../assets/25.png" alt="" />
    </div>
    <div class="img_box">
      <img src="../../assets/26.png" alt="" />
      <a :href="'tel:'+tel" class="btn4"></a>
    </div>
    <div class="img_box">
      <img src="../../assets/27.png" alt="" />
      <img src="../../assets/43.jpg" alt="" class="qr_code" />
    </div>

    <div class="safe_area"></div>
    <div class="phone_box">
      <img src="../../assets/36.png" alt="" />
      <a :href="'tel:'+tel">{{tel}}</a>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      tel: "",
    };
  },
  computed: {},
  mounted() {
    this.tel = this.$route.query.tel || "400-888-8888";
  },
  methods: {},
};
</script>
<style lang='scss' scoped>
.ml_page {
  .img_box{
    position: relative;
    img {
      display: block;
      width: 100%;
    }
    .qr_code{
      width: 160px;
      height: 160px;
      position: absolute;
      top: 50px;
      left: 0;
      right: 0;
      bottom: 0;
      margin: auto;
    }
    .btn1{
      width: 73%;
      height: 9%;
      position: absolute;
      top: 83.5%;
      left: 0;
      right: 0;
      bottom: 0;
      margin: auto;
      -webkit-tap-highlight-color: rgba(0,0,0,0);
    }
    .btn2{
      width: 73%;
      height: 9%;
      position: absolute;
      top: 84.5%;
      left: 0;
      right: 0;
      bottom: 0;
      margin: auto;
      -webkit-tap-highlight-color: rgba(0,0,0,0);
    }
    .btn3{
      width: 73%;
      height: 13%;
      position: absolute;
      top: 76.8%;
      left: 0;
      right: 0;
      bottom: 0;
      margin: auto;
      -webkit-tap-highlight-color: rgba(0,0,0,0);
    }
    .btn4{
      width: 73%;
      height: 14%;
      position: absolute;
      top: 68.8%;
      left: 0;
      right: 0;
      bottom: 0;
      margin: auto;
      -webkit-tap-highlight-color: rgba(0,0,0,0);
    }
  }
  .safe_area {
    width: 100%;
    height: 60px;
    height: constant(60px + env(safe-area-inset-bottom)); // tabBar原高度（60px改成你项目自己的值）+安全距离,兼容 iOS < 11.2
    height: calc(60px + env(safe-area-inset-bottom)); // 兼容 iOS >= 11.2
    background: #ffffff;
  }
  .phone_box {
    width: 100%;
    height: 60px;
    background: #ffffff;
    position: fixed;
    bottom: 0;

    padding-bottom: constant(safe-area-inset-bottom); // tabBar留出底部安全距离, 兼容 iOS < 11.2
    padding-bottom: env(safe-area-inset-bottom); // 兼容 iOS >= 11.2

    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 20px;
      height: 20px;
      margin-right: 10px;
    }
    a {
      color: #327fff;
      font-size: 18px;
      font-weight: bold;
      text-decoration: none;
    }
  }
}
</style>